import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from "react";
import { getTimeAgo, getTimeAgoShort } from "@/helpers/Helpers";
export default function CommonTimeAgo(t0) {
  const $ = _c(16);
  const {
    timestamp,
    short: t1,
    className: t2
  } = t0;
  const short = t1 === undefined ? false : t1;
  const className = t2 === undefined ? "tw-text-sm sm:tw-text-base" : t2;
  const [, forceUpdate] = useState(0);
  let t3;
  if ($[0] !== forceUpdate) {
    t3 = () => {
      const interval = setInterval(() => {
        forceUpdate(_temp);
      }, 60000);
      return () => {
        clearInterval(interval);
      };
    };
    $[0] = forceUpdate;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  let t4;
  if ($[2] !== short || $[3] !== timestamp) {
    t4 = [timestamp, short];
    $[2] = short;
    $[3] = timestamp;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  useEffect(t3, t4);
  let t5;
  if ($[5] !== short || $[6] !== timestamp) {
    t5 = short ? getTimeAgoShort(timestamp) : getTimeAgo(timestamp);
    $[5] = short;
    $[6] = timestamp;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  const text = t5;
  let isoTimestamp;
  let t6;
  if ($[8] !== timestamp) {
    const date = new Date(timestamp);
    isoTimestamp = date.toISOString();
    t6 = date.toLocaleString();
    $[8] = timestamp;
    $[9] = isoTimestamp;
    $[10] = t6;
  } else {
    isoTimestamp = $[9];
    t6 = $[10];
  }
  const readableTimestamp = t6;
  const t7 = `tw-whitespace-nowrap tw-font-normal tw-text-iron-500 ${className}`;
  let t8;
  if ($[11] !== isoTimestamp || $[12] !== readableTimestamp || $[13] !== t7 || $[14] !== text) {
    t8 = <time className={t7} dateTime={isoTimestamp} title={readableTimestamp}>{text}</time>;
    $[11] = isoTimestamp;
    $[12] = readableTimestamp;
    $[13] = t7;
    $[14] = text;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  return t8;
}
function _temp(value) {
  return value + 1;
}